import HotspotImage from './HotspotImage';

const DoubleImageElement = ({ images, size }) => {
  return (
    <div
      className={`w-full max-${size}-content flex flex-col items-center space-y-4 tablet:space-y-10 laptop:flex-row laptop:space-x-[80px] laptop:space-y-0 laptop:px-[56px]`}
    >
      {images.map((image, idx) => (
        <div
          key={`image_${idx}`}
          className="aspect-square w-full max-w-[854px] laptop:w-[854px] relative"
        >
          <HotspotImage image={image} />
        </div>
      ))}
    </div>
  );
};

export default DoubleImageElement;
